import script from "./HeroMock.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroMock.vue?vue&type=script&setup=true&lang=js"

import "./HeroMock.vue?vue&type=style&index=0&id=5895d9ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5895d9ff"]])

export default __exports__